console.log('third-level-menu.js v4 loaded');

(function () {
  function initThirdLevel() {
    document.querySelectorAll('a[data-submenu]').forEach(function (anchor) {
      const existing = anchor.parentElement.querySelector('.third-level-submenu');
      if (existing) existing.remove();

      let items;
      try { items = JSON.parse(anchor.dataset.submenu); } catch(e) { return; }
      if (!items || items.length === 0) return;

      const parent = anchor.parentElement;
      parent.style.position = 'relative';

      const ul = document.createElement('ul');
      ul.className = 'third-level-submenu';
      ul.style.cssText = 'display:none;position:absolute;left:100%;top:0;min-width:220px;background:#fff;border:1px solid #e0e0e0;padding:12px 0;z-index:9999;box-shadow:0 4px 16px rgba(0,0,0,0.12);list-style:none;margin:0;';
      items.forEach(function(item) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = item.url;
        a.style.cssText = 'display:block;padding:6px 20px;white-space:nowrap;';
        a.textContent = item.title;
        li.appendChild(a);
        ul.appendChild(li);
      });
      parent.appendChild(ul);

      anchor.addEventListener('mouseenter', function() { ul.style.display = 'block'; });
      parent.addEventListener('mouseleave', function() { ul.style.display = 'none'; });
    });
  }

  var observer = new MutationObserver(function() {
    if (document.querySelectorAll('a[data-submenu]').length > 0) {
      observer.disconnect();
      initThirdLevel();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', initThirdLevel);
})();
